import {CONSTANTS, formatNumbers, isCampaignRetention} from '../../utils';

import StatusesMap from './statusesMap';
import {CampaignTypes} from '../../../../types/src';

function getFullItem(item, campaign) {
  const allStatuses = StatusesMap.getAllStatuses();
  const status = allStatuses.get(item.status);
  if (status) {
    // if (isCampaignRetention(campaign) && item.status === CONSTANTS.audience_statuses.created) {
    //   return {...item, ...status, label: 'to be nurtured'};
    // }
    return {...item, ...status};
  }
  return {...item, label: item.status, color: '#bfbfbf'};
}

function getInitialOptionsForCampaign(campaign) {
  const acquisitionDefault = {
    invited: 0,
    to_be_processed: 0,
    error_company_excluded: 0,
    error_invite_exist: 0,
    error_pending: 0,
    errors: 0,
  };
  const retentionDefault = {
    nurtured: 0,
    to_be_processed: 0,
    error_company_excluded: 0,
    error_response_or_followup_detected: 0,
    error_exclude_responders: 0,
    error_contacted_by_excluded_campaign: 0,
    error_open_sequence: 0,
    error_not_gx_connection: 0,
    error_in_mail: 0,
    error_different_typed_message: 0,
    error_do_not_send_tag: 0,
    errors: 0,
  };
  const inmailDefault = {
    invited_free_inmail: 0,
    invited_credit_used: 0,
    to_be_processed: 0,
    error_company_excluded: 0,
    error_invite_exist: 0,
    error_pending: 0,
    errors: 0,
  };
  const initialOptions = {
    [CampaignTypes.Acquisition]: {
      ...acquisitionDefault,
      error_email_required: 0,
      error_different_typed_invite: 0,
    },
    [CampaignTypes.AcquisitionBasic]: {
      ...acquisitionDefault,
    },
    [CampaignTypes.AcquisitionMessageRequest]: {
      ...acquisitionDefault,
    },
    [CampaignTypes.AcquisitionInmail]: {...inmailDefault},
    [CampaignTypes.AcquisitionViaImport]: {
      ...acquisitionDefault,
      error_no_email: 0,
    },
    [CampaignTypes.AcquisitionCsv]: {
      ...acquisitionDefault,
      error_email_required: 0,
      error_different_typed_invite: 0,
      error_profile_url: 0,
    },
    [CampaignTypes.AcquisitionCsvRb2b]: {
      ...acquisitionDefault,
      error_email_required: 0,
      error_different_typed_invite: 0,
      error_profile_url: 0,
    },
    [CampaignTypes.AcquisitionCsvInstantly]: {
      ...acquisitionDefault,
      error_email_required: 0,
      error_different_typed_invite: 0,
      error_profile_url: 0,
    },
    [CampaignTypes.AcquisitionCsvSquid]: {
      ...acquisitionDefault,
      error_email_required: 0,
      error_different_typed_invite: 0,
      error_profile_url: 0,
    },
    [CampaignTypes.AcquisitionCsvWebhook]: {
      ...acquisitionDefault,
      error_email_required: 0,
      error_different_typed_invite: 0,
      error_profile_url: 0,
    },
    [CampaignTypes.AcquisitionCsvVector]: {
      ...acquisitionDefault,
      error_email_required: 0,
      error_different_typed_invite: 0,
      error_profile_url: 0,
    },
    [CampaignTypes.AcquisitionCsvApi]: {
      ...acquisitionDefault,
      error_email_required: 0,
      error_different_typed_invite: 0,
      error_profile_url: 0,
    },
    [CampaignTypes.AcquisitionCsvZapier]: {
      ...acquisitionDefault,
      error_email_required: 0,
      error_different_typed_invite: 0,
      error_profile_url: 0,
    },
    [CampaignTypes.AcquisitionCsvLikedPost]: {
      ...acquisitionDefault,
      error_email_required: 0,
      error_different_typed_invite: 0,
      error_profile_url: 0,
    },
    [CampaignTypes.AcquisitionCsvAudienceList]: {...acquisitionDefault, 
      error_email_required: 0,
      error_different_typed_invite: 0,
      error_profile_url: 0,
    },
    [CampaignTypes.AcquisitionCsvEnrichment]: {...acquisitionDefault, 
      error_email_required: 0,
      error_different_typed_invite: 0,
      error_profile_url: 0,
    },
    [CampaignTypes.Retention]: {...retentionDefault},
    [CampaignTypes.RetentionCsv]: {
      ...retentionDefault,
      error_profile_url: 0,
    },
    [CampaignTypes.RetentionTags]: {...retentionDefault},
    [CampaignTypes.RetentionActions]: {...retentionDefault},
    [CampaignTypes.RetentionCsvAudienceList]: {...retentionDefault},
    [CampaignTypes.RetentionCsvEnrichment]: {...retentionDefault},
  };
  return initialOptions[campaign.type];
}

export function mapRawStatsToItems(stats, campaign) {
  const items: any = getInitialOptionsForCampaign(campaign);
  const validStatuses = StatusesMap.getValidStatuses();
  const errorStatuses = StatusesMap.getErrorStatuses();
  for (const s of stats) {
    if (validStatuses.has(s.status)) {
      items[s.status] = s.total;
    } else if (!errorStatuses.has(s.status)) {
      items.errors += s.total;
    }
  }
  const preparedItems = Object.keys(items)
    .map(i => {
      const itemData = stats.find(s => s.status === i);
      return getFullItem(
        {status: i, total: formatNumbers(items[i]), details: itemData?.details ?? false},
        campaign
      )
    }
  );
  preparedItems.sort((a, b) => b.priority - a.priority);
  return preparedItems;
}

export function mapRawStatsToErrors(stats, campaign) {
  const items: any = {};
  const errorStatuses = StatusesMap.getErrorStatuses();
  for (const s of stats) {
    if (errorStatuses.has(s.status)) {
      items[s.status] = s.total;
    }
  }
  const preparedItems = Object.keys(items).map(i => getFullItem({status: i, total: formatNumbers(items[i])}, campaign));
  preparedItems.sort((a, b) => b.priority - a.priority);
  return preparedItems;
}
